"use strict";

import {find, closest, on} from "../libs/@elements/dom-utils";
import {onFind} from "../libs/@elements/init-modules-in-scope";

export function init () {

    onFind('.js-collapsing-checkbox__input', function (item) {
        on('change', function(event) {

            let $collapseParent = closest('.js-collapsing-checkbox', item);
            let $collapseArea = find('.js-collapsing-checkbox__add', $collapseParent);

            if (item.checked === true){
                $collapseArea.removeAttribute('hidden');
            } else {
                $collapseArea.setAttribute('hidden',true);
            }

        }, item);
    });


    let collapsingCheckbox = find('.js-collapsing-checkbox__input');
    if(collapsingCheckbox) {
        if(collapsingCheckbox.checked) {
            let $collapseParent = closest('.js-collapsing-checkbox', collapsingCheckbox);
            let $collapseArea = find('.js-collapsing-checkbox__add', $collapseParent);
            $collapseArea.removeAttribute('hidden');
        }
    }
}